var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-end align-items-center"},[_c('PfDescriptionColumn',{ref:"descriptionColumn",attrs:{"row":_vm.row,"index":_vm.index,"datatable":_vm.datatable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }